// src/components/asset/StructureShipEditor.jsx
import React from 'react';
import {
  Box, Typography, Paper, Grid, TextField, FormControl, InputLabel, Select, MenuItem, Alert
} from '@mui/material';
import { Build as BuildIcon, LockOutlined as LockIcon } from '@mui/icons-material';

const SIZE_TIERS = ['nano', 'micro', 'small', 'medium', 'large', 'huge', 'capital', 'megastructure'];
const TECH_LEVELS = Array.from({ length: 10 }, (_, i) => i + 1);

const StructureShipEditor = ({ 
  data, 
  onChange, 
  isLocked, 
  isDockMode 
}) => {
  if (!data) return null;

  const handleChange = (field, value) => {
    if (!isLocked && onChange) {
      onChange({ ...data, [field]: value });
    }
  };

  return (
    <Paper sx={{ p: 2, height: '100%' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        {isLocked ? <LockIcon color="error" sx={{ mr: 1 }} /> : <BuildIcon color="primary" sx={{ mr: 1 }} />}
        <Typography variant="subtitle1">
          Параметры {isLocked ? '(Только просмотр)' : ''}
        </Typography>
      </Box>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField 
            fullWidth 
            size="small" 
            label="Название" 
            value={data.name || ''} 
            onChange={(e) => handleChange('name', e.target.value)}
            disabled={isLocked}
          />
        </Grid>
        
        <Grid item xs={6}>
          <FormControl fullWidth size="small" disabled={isLocked}>
            <InputLabel>Размер</InputLabel>
            <Select 
              value={data.size_tier || data.ship_size || 'medium'} 
              label="Размер"
              onChange={(e) => handleChange('size_tier', e.target.value)}
            >
              {SIZE_TIERS.map(s => <MenuItem key={s} value={s}>{s}</MenuItem>)}
            </Select>
          </FormControl>
        </Grid>
        
        <Grid item xs={6}>
          <FormControl fullWidth size="small" disabled={isLocked}>
            <InputLabel>Tech Level</InputLabel>
            <Select 
              value={data.tech_level || 5} 
              label="Tech Level"
              onChange={(e) => handleChange('tech_level', parseInt(e.target.value))}
            >
              {TECH_LEVELS.map(l => <MenuItem key={l} value={l}>{l}</MenuItem>)}
            </Select>
          </FormControl>
        </Grid>
        
        <Grid item xs={12}>
          <TextField 
            fullWidth 
            multiline 
            rows={4} 
            size="small" 
            label="Описание" 
            value={data.description || ''} 
            onChange={(e) => handleChange('description', e.target.value)}
            disabled={isLocked}
          />
        </Grid>
      </Grid>

      {isDockMode && isLocked && (
        <Alert severity="info" sx={{ mt: 2 }}>
          Базовые параметры заблокированы, так как объект уже размещён в мире. 
          Доступна только модульная модернизация.
        </Alert>
      )}
    </Paper>
  );
};

export default StructureShipEditor;